import React, { useEffect, useState } from "react";
import { getOnlineRegistration } from "../Service/Api";
import { Link } from 'react-router-dom'
const OnlineRegistration = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
   const fetchData = async () => {
     try {
       const data = await getOnlineRegistration();
       console.log(data)
       setData(data);
     } catch (error) {
       console.error("Error fetching online registration data:", error);
     }  
   };
   fetchData();
 }, []);
 
  return (
    <>
           
    
<div className="OnlineR">
    <span className="bounce1">
  <Link to="https://tafs.campuscare.info//Logon/TPLoginRegistration" target="_blank" className="parantlogo ">  ONLINE ADMISSION FOR AIR FORCE CATEGORY  </Link>
     
 
  </span>
  <span className="bounce1" style={{display:data.length>0?`block`:'none'}}>
  <Link to="#" target="_blank" className="parantlogo ">  {data[0]?.title}  </Link>
     <Link to={`https://webapi.entab.info/api/image/${data[0]?.attachments[0]}`} target="_blank" className=""> <i className="bi bi-paperclip"></i></Link> 
 
  </span>
</div> 
 
    </>
  )
}

export default OnlineRegistration
